<app-steps [step]='2'></app-steps>

<div class="row" *ngIf="app.config!=null">
    <div class="col">
        <h3 class="main-title text-center" [innerHTML]="app.config.page1Header"></h3>
        <h4 [innerHTML]="app.config.page1SubHeader"></h4>
    </div>
</div>

<div class="row" *ngFor="let group of giftVoucherGroups">
    <div class="col">
        <h3 *ngIf="app.config.showGroupHeader">{{group.name}}</h3>
        <p *ngIf="app.config.showGroupHeader">{{group.description}}</p>
        <div class="row item-container">
            <div class="col-sm-3 col-6" *ngFor="let giftVoucher of group.giftVouchers;">
                <div class="item shadow-sm" style="border:1px solid #eee">
                    <img onerror="this.src='assets/images/gv-image.png'" src="assets/images/{{giftVoucher.imageUrl}}"
                        class="card-img-top img-fluid" alt="{{giftVoucher.imageUrl}}">
                    <div class="card-body" style="flex-grow: 1;" *ngIf="app.config.showItemPriceAndName">
                        <h3 class="card-title">{{giftVoucher.name}}
                            <br>
                            <small class="price">
                                <span [innerHTML]="app.config.currencySymbol"></span>{{giftVoucher.fee | number :
                                '1.2-2'}}
                            </small>
                            <!-- <small class="price">{{giftVoucher.fee | currency }}</small> -->
                        </h3>
                    </div>
                    <div class="card-footer bg-transparent" style="border:none" *ngIf="app.config.showAddToButton">
                        <a class="btn btn-blue full-width" (click)="addToBasket(giftVoucher)">
                            {{app.config.giftVoucherListAddToCartText}}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>